import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const chargeCalculationTypesAdapter = getAdapter({ idFieldName: 'value' });

const chargeCalculationTypesSlice = createSlice({
  name: 'chargeCalculationTypes',
  initialState: chargeCalculationTypesAdapter.getInitialState(),
  reducers: {
    setChargeCalculationTypes: (state, { payload: { chargeCalculationTypes } }) => {
      chargeCalculationTypesAdapter.setAll(state, chargeCalculationTypes);
    },
  },
});

const selectors = chargeCalculationTypesAdapter.getSelectors(({ chargeCalculationTypes }) => chargeCalculationTypes);

export const getChargeCalculationTypes = (state) => selectors.selectAll(state);

export const { setChargeCalculationTypes } = chargeCalculationTypesSlice.actions;

export default chargeCalculationTypesSlice.reducer;